module.exports = __webpack_public_path__ + "img/pizza-3.9cdb9b79.jpg";